import { DeskWallToSimpleSapElementMapper } from '../desk/deskWallToSimpleSapElementMapper';

export class DressingWallToSimpleSapElementMapper
    extends DeskWallToSimpleSapElementMapper {

}